import React from 'react';
import './about.css';
import OUS from '../assets/Ous.jpg'
import { HiOutlineDesktopComputer } from 'react-icons/hi'
import { FiUsers } from 'react-icons/fi'
import { AiFillProject } from 'react-icons/ai'

const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className='container about__container'>
        <div className='about__me'>
          <div className='about__me-image'>
            <img src={OUS} alt="About Me" />
          </div>
        </div>

        <div className='about__content'>
          <div className="about__cards">
            <article className='about__card'>
              <HiOutlineDesktopComputer className='about__icon'/>
              <h5>Experience</h5>
              <small>3+ Years</small>
            </article>
            {/* Second article */}
            <article className='about__card'>
              <FiUsers className='about__icon'/>
              <h5>Clients</h5>
              <small>100+ Clients</small>
            </article>
            {/* Third article */}
            <article className='about__card'>
              <AiFillProject className='about__icon'/>
              <h5>Projects</h5>
              <small>40+ Projects</small>
            </article>
          </div>

          <p>
          Are you looking to bring your ideas to life using software and digital solution? Look no further! We specialize in creating exceptional software products, from small to large scale. With a diverse team of engineers,
          we can handle projects of any size or outsource work to meet your needs. We work in an agile manner, breaking down your project into manageable sprints. Each sprint focuses on delivering a specific aspect of the project every week, ensuring that the entire project is completed efficiently. 
          <br /> <br />
          What's more, we offer live programming classes in DevOps, Java, Python, and JavaScript, complete with meaningful 
          projects to equip you with the technical skills necessary for success. When you choose us, you can expect personalized attention and regular, easy-to-understand updates throughout the project.
          Our strong communication and personable approach set us apart, and we're committed to building long-lasting relationships. As a full-time freelancer, I guarantee a response within 24 hours. 
          Let's work together to ensure the success of your business. Reach out today and let's get started on something great!
          </p>
          <a href="#contact" className='btn btn-primary'>Get In Touch</a>
        </div>
      </div>
    </section>
  )
}

export default About;